import React from "react";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import Typography from "@visa/vds/typography";
import { DataTable, Grid, List, Tbody, Td, Th, Thead, Tr } from "@visa/vds";
import MCSReadonlyField from "components/MCSReadonlyField";
const ResourcePage = () => {

    return (
        <>
            <Grid style={{marginLeft: "20px"}}>
                <Row>
                    <Col>
                        <Typography tag="h1" variant="headline">Contact Visa Support</Typography>
                        <Typography variant="body" style={{ marginTop: "5px", marginBottom: "0px"}}>
                            Contact the support team for your region using the email address below:
                        </Typography>
                    </Col>
                </Row>
                <Row>
                    <List>
                        <li>
                            <MCSReadonlyField
                                label="Europe:"
                                text={<a href="mailto:customersupport@visa.com">customersupport@visa.com</a>}
                            ></MCSReadonlyField>
                        </li>
                        <li>
                            <MCSReadonlyField
                                label="Latin America, and Caribbean (LAC):"
                                text="Visa's Account Support Center (ASC) through the Visa Client Support Application (VCSA), available via Visa Access"
                            ></MCSReadonlyField>
                        </li>
                        <li>
                            <MCSReadonlyField
                                label="Asia Pacific (AP):"
                                text={<a href="mailto:isupport@visa.com">isupport@visa.com</a>}
                            ></MCSReadonlyField>
                        </li>
                        <li>
                            <MCSReadonlyField
                                label="North America (NA):"
                                text={<a href="mailto:esupport@visa.com">esupport@visa.com</a>}
                            ></MCSReadonlyField>
                        </li>
                        <li>
                            <MCSReadonlyField
                                label="Central Europe, Middle East, and Africa (CEMEA):"
                                text={<a href="mailto:csupport@visa.com">csupport@visa.com</a>}
                            ></MCSReadonlyField>
                        </li>
                    </List>
                </Row>
                <Row>
                    <div style={{marginTop: "20px"}}>

                    </div>
                </Row>
                <Row>
                    <Col>
                        <Typography tag="h1" variant="headline" style={{zIndex: "1", position: "relative"}}>More Visa Secure links</Typography>
                        <Typography style={{ marginTop: "5px", marginBottom: "-40px", zIndex: "100", position: "relative" }} variant="body">
                            The links below have additional information about Visa Secure.
                        </Typography>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <DataTable size="compact" style={{ marginTop: "-20px", maxWidth: "700px"}}>
                            <Thead>
                                <Tr>
                                    <Th scope="col"></Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                <Tr>
                                    <Th scope="row">Visa Access
                                        <List>
                                            <li><a href="https://secure.visaonline.com/pages/4.1926" target="_blank" rel="noopener noreferrer">Visa Secure</a></li>
                                            <li><a href="https://secure.visaonline.com/pages/5.3056" target="_blank" rel="noopener noreferrer">Digital Authentication Framework (DAF)</a></li>
                                            <li><a href="https://secure.visaonline.com/pages/4.744" target="_blank" rel="noopener noreferrer">Client Information Questionnaires (CIQ)</a></li>
                                            <li><a href="https://secure.visaonline.com/pages/5.2576" target="_blank" rel="noopener noreferrer">Visa Secure eCommerce Certificates</a></li>
                                        </List>
                                    </Th>
                                </Tr>
                                <Tr>
                                    <Th scope="row"><a href="https://partner.visa.com/" target="_blank" rel="noopener noreferrer">Visa Partner Portal</a></Th>
                                </Tr>
                                <Tr>
                                    <Th scope="row"><a href="https://www.visa.com" target="_blank" rel="noopener noreferrer">Visa.com</a></Th>
                                </Tr>
                                <Tr>
                                    <Th scope="row"><a href="https://developer.visa.com/pages/visa-3d-secure" target="_blank" rel="noopener noreferrer">VDP.com</a></Th>
                                </Tr>
                                <Tr>
                                    <Th scope="row">EMVCo
                                        <List>
                                            <li><a href="https://www.emvco.com/approved-products/" target="_blank" rel="noopener noreferrer">Information on EMVCo</a></li>
                                        </List>
                                    </Th>
                                </Tr>
                            </Tbody>
                        </DataTable>
                    </Col>
                </Row>
            </Grid>
        </>
    );
}
export default ResourcePage